import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import {
    MuiThemeProvider,
    createMuiTheme,
    makeStyles,
    createStyles,
} from "@material-ui/core/styles";
import { timeDurationToTime } from "../../utilities/utility";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, Grid, IconButton, TextField } from "@material-ui/core";
import { checkUserAccess, db, getCheckSession } from "../../apis/auth";
import { addDoc, collection, doc, getDocs, orderBy, query, updateDoc } from "firebase/firestore";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CloseIcon from "@material-ui/icons/Close";
import { format } from "date-fns";
import { getDataFromAPICall, getHistoryFromAPICall, handleSave } from "../../query/config.query";
import { NotificationManager } from "react-notifications";



export const SLCFirmwarePhase3 = () => {

    const classes = useStyles();
    const [slcData, setSlcData] = useState([]);
    const [isOpenDialog, setIsOpenDialog] = useState(false);
    const [slcDialog, setSlcDialog] = useState({ url: "", sha: "", ver: 0 });
    const [slcDocId, setSlcDocId] = useState(null);
    const history = useHistory();
    const [historyDialog, setHistoryDialog] = useState(false);
    const [scheduleHistoryData, setHistoryData] = useState([]);

    useEffect(async () => {
        console.log("========== LiveMeterFeed : OnInit() ==========");
        var sessionStatus = await getCheckSession();
        if (sessionStatus === false) {
            history.push("/");
            return;
        }
        getSlcInfo();
    }, []);

    const getSlcHistory = () => {
        getHistoryFromAPICall("fw_upd_hist_slc_3ph")
            .then((historyList) => {
                setHistoryData(historyList);
                setHistoryDialog(true)
            })
            .catch(() => {
                NotificationManager.error("Unable to get slc history record", "", 3000);
            });
    }

    const getSlcInfo = () => {
        getDataFromAPICall('fw_updates', "slc_3ph")
            .then((result) => {
                const { docId, configInfo } = result;
                setSlcDocId(docId);
                setSlcDialog(configInfo)
                setSlcData(configInfo)
            })
            .catch(() => {
                NotificationManager.error("Unable to get slc firmware data", "", 3000);
            });
    }

    const handleSelectedDate = (data, field) => {
        let { target: { value = "" } = {} } = data;
        setSlcDialog((prevState) => ({
            ...prevState,
            [field]: value
        }));
    };
    const handleEdit = () => {
        setIsOpenDialog(true);
    };

    const getScheduledTime = () => {
        const { url = "", sha = "", ver = "" } = slcData;
        return (
            <Grid xs={6} sm={8}>
                <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>URL</span>
                    <span>{url}</span>
                </div>
                <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>SHA</span>
                    <span>{sha}</span>
                </div>
                <div style={{ padding: '5px', fontWeight: 'normal', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontWeight: 'bold' }}>Version</span>
                    <span>{ver}</span>
                </div>
            </Grid>
        );
    };
    var editSLC = checkUserAccess("edit_config")
    const handleClose = () => {
        setIsOpenDialog(false);
    };
    const getScheduleHistoryColumnList = () => {
        return [
            {
                title: 'Firmware URL',
                render: ({ url: url = 0 }) => {
                    if (url != 0) {
                        return url;
                    }
                    return 0;
                },
            },
            {
                title: 'SHA',
                render: ({ sha: sha = 0 }) => {
                    if (sha != 0) {
                        return sha;
                    }
                    return 0;
                },
            },
            {
                title: 'Version',
                render: ({ ver: ver = 0 }) => {
                    if (ver != 0) {
                        return ver;
                    }
                    return 0;
                },
            },
            {
                title: 'Modified By',
                render: ({ user: user = 0 }) => {
                    if (user != 0) {
                        return user;
                    }
                    return 0;
                },
            },
            {
                title: 'Date',
                render: ({ ch_dt: ch_dt = 0 }) => {
                    if (ch_dt != 0) {
                        return format(ch_dt.toDate(), "dd/MM/yyyy, hh:mm a");
                    }
                    return 0;
                },
            },
        ];
    };

    const [formErrors, setFormErrors] = useState({});

    const validateForm = () => {
        const errors = {};
        if (!slcDialog.url) {
            errors.url = 'Firmware URL is required';
        }
        if (!slcDialog.sha) {
            errors.sha = 'SHA is required';
        }
        if (slcDialog.url && !/^https?:\/\/[^\s$.?#].[^\s]*$/i.test(slcDialog.url)) {
            errors.url = 'Invalid URL format';
        }
        setFormErrors(errors);
        return Object.keys(errors).length === 0;  // Returns true if no errors
    };
    const getSaveDisabledStatus = () => {
        const { ver, ...slcDialogWithoutVer } = slcDialog;
        const { ver: ver1, ...slcDataWithoutVer } = slcData;

        if (Object.keys(slcDialogWithoutVer).length !== Object.keys(slcDataWithoutVer).length) {
            return false;
        }

        return Object.entries(slcDialogWithoutVer).every(([key, value]) => slcDataWithoutVer[key] === value);
    };

    return (
        <div className="dim-schedule">
            <Grid container>
                <Grid xs={12} sm={12}>
                    <div className="settings-schedule-wrapper">
                        <h5 className="header">SLC Firmware Phase 3
                        </h5>
                        <div style={{ padding: '10px' }}>{getScheduledTime()}</div>
                        <div className="edit-btn-wrapper">
                            <Button
                                variant="contained"
                                className="edit-btn"
                                onClick={() => {
                                    getSlcHistory();
                                }}>
                                History
                            </Button>
                            {editSLC && <Button
                                variant="contained"
                                className="edit-btn"
                                onClick={() => {
                                    handleEdit();
                                }}>

                                Edit
                            </Button>}

                        </div>
                    </div>
                </Grid>

            </Grid>

            <Dialog
                className="change-schedule-dialog"
                onClose={handleClose}
                aria-labelledby="editTime-dialog-title"
                open={isOpenDialog}
                fullWidth
                PaperProps={{
                    component: 'form',
                    onKeyDown: (event) => {
                        if (event.key === 'Enter') {
                            event.preventDefault();
                        }
                    },
                    onSubmit: (event) => {
                        event.preventDefault();
                        if (validateForm()) {
                            handleSave(slcDocId, slcDialog, 'fw_updates', 'slc_3ph').then(() => {
                                NotificationManager.success("Successfully Save Slc Firmware", "", 3000);
                                setIsOpenDialog(false);
                                getSlcInfo();
                            }).catch(() => {
                                NotificationManager.error("Faild to update slc firmware data", "", 3000);
                            });
                        }
                    },
                }}
            >
                <DialogTitle id="editTime-dialog-title" onClose={handleClose}>
                    SLC Firmware Phase 1
                    <IconButton
                        aria-label="close"
                        className={classes.closeButton}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="max voltage"
                            label="Firmware URL"
                            type="text"
                            onChange={(e) => handleSelectedDate(e, 'url')}
                            value={slcDialog.url}
                            error={Boolean(formErrors.url)}
                            helperText={formErrors.url}
                        />
                    </FormControl>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            margin="dense"
                            id="min voltage"
                            label="SHA"
                            type="text"
                            onChange={(e) => handleSelectedDate(e, 'sha')}
                            value={slcDialog.sha}
                            error={Boolean(formErrors.sha)}
                            helperText={formErrors.sha}
                        />
                    </FormControl>
                    <FormControl className="dialog-form" style={{ width: '100%', margin: '0px 0' }}>
                        <TextField
                            margin="dense"
                            id="Version"
                            label="Version"
                            type="number"
                            onWheel={(e) => {
                                e.target.blur();
                            }}
                            disabled
                            value={slcDialog.ver + 1 || 1}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="save-btn"
                        type="submit"
                        disabled={getSaveDisabledStatus()}
                    >
                        Save
                    </Button>
                    <Button className="save-btn" onClick={getSaveDisabledStatus}>
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog className="history-dialog" open={historyDialog} onClose={() => { setHistoryDialog(false) }} aria-labelledby="form-dialog-title" fullWidth maxWidth={'md'}>
                <DialogTitle id="form-dialog-title"> SLC Firmware Phase 3 History </DialogTitle>
                <DialogContent>

                    <MaterialTable
                        style={{
                            // margin: "20px 0",
                            width: "100%",
                        }}
                        className={classes.table}
                        title={""}
                        columns={getScheduleHistoryColumnList()}
                        data={scheduleHistoryData}
                        options={{
                            exportButton: false,
                            // grouping: true,
                            search: false,
                            selection: false,
                            sorting: true,
                            pageSize: 5,
                            headerStyle: {
                                backgroundColor: "#0071CE",
                                color: "#FFF",
                                fontSize: "0.9em",
                                textAlign: "center",
                            },
                            actionsColumnIndex: -1,
                            emptyRowsWhenPaging: false,
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setHistoryDialog(false) }} color="primary">
                        CLOSE
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

const useStyles = makeStyles((theme) =>
    createStyles({
        button: {
            margin: theme.spacing(1),
        },
        table: {
            minWidth: 650,
        },
        root: {
            width: "100%",
        },
        formControl: {
            margin: theme.spacing(1),
            minWidth: 120,
            marginRight: 20,
        },
        selectEmpty: {
            marginTop: theme.spacing(2),
        },
        closeButton: {
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    })
);